import { Skeleton } from '@mntn/ui-components'
import { AirDateInfoSkeleton } from './air-date-info'
import { CampaignActionsSkeleton } from './campaign-actions'
import { DealInfoSkeleton } from './deal-info'

export const OrderItemListCardSkeleton = () => {
  return (
    <div className="space-y-1">
      <div className="relative shadow-md rounded-sm border border-border bg-surface-bg-inverse">
        <div className="px-6 pt-6 pb-4">
          <div className="flex items-center gap-6">
            {/* Thumbnail */}
            <div className="shrink-0">
              <DealInfoSkeleton />
            </div>

            {/* Content */}
            <div className="flex flex-col flex-1 min-w-0 gap-2">
              <AirDateInfoSkeleton />
              <div className="flex flex-col gap-2">
                <Skeleton dark className="h-7 w-2/3" />
                <Skeleton dark className="h-4 w-1/2" />
              </div>
              {/* Spend meter */}
              <div className="flex flex-col gap-1 pt-1">
                <div className="flex items-center justify-between">
                  <Skeleton dark className="h-3 w-12" />
                  <Skeleton dark className="h-3 w-28" />
                </div>
                <Skeleton dark className="h-2 w-full rounded-full" />
                <div className="flex items-center justify-between">
                  <Skeleton dark className="h-3 w-24" />
                  <Skeleton dark className="h-3 w-20" />
                </div>
              </div>
            </div>

            {/* Campaign Actions */}
            <div className="shrink-0 self-end pb-1 min-w-[260px]">
              <CampaignActionsSkeleton />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
